// extracted by mini-css-extract-plugin
export default {"innerContainer":"DoctorLandingPage_innerContainer__HnsF4"};